import { appType, SECTOR_CODE } from "../config/config";

export const typePage = {
  INSCRIPTIONS: "inscripciones",
  INSCRIPTION_COURSES: "inscripciones-cursos",
  INSCRIPTION_POSTGRADE: "inscripciones-postgrado",
};

export const onlyIscriptions = () => {
  return appType == typePage.INSCRIPTIONS;
};

export const onlyIscriptionCourses = () => {
  return appType == typePage.INSCRIPTION_COURSES;
};

export const onlyIscriptionPostGrado = () => {
  return appType == typePage.INSCRIPTION_POSTGRADE;
};

export const onlyIscriptionBySector = () => {
  return SECTOR_CODE;
};

export const allInscriptions = () => {
  return (
    appType == typePage.INSCRIPTION_COURSES || appType == typePage.INSCRIPTIONS || appType == typePage.INSCRIPTION_POSTGRADE
  );
};
